import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

const NotFound = () => {
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth0();

    const handleGoHome = () => {
        navigate(isAuthenticated ? '/dashboard' : '/');
    };

    return (
        <section className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
            <div className="max-w-lg w-full text-center">
                {/* Animated 404 illustration */}
                <div className="mb-8 relative">
                    <div className="text-[9rem] font-black leading-none text-transparent bg-clip-text select-none"
                        style={{ backgroundImage: 'linear-gradient(135deg, #074c9a 0%, #2563eb 50%, #60a5fa 100%)' }}>
                        404
                    </div>
                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                        <div className="w-32 h-32 rounded-full bg-blue-100 opacity-50 blur-2xl" />
                    </div>
                </div>

                {/* Icon */}
                <div className="mx-auto mb-6 w-20 h-20 rounded-2xl bg-blue-50 flex items-center justify-center shadow-sm">
                    <svg className="w-10 h-10 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                            d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>

                <h1 className="text-3xl font-bold text-gray-900 mb-3">Page Not Found</h1>
                <p className="text-gray-500 mb-8 leading-relaxed">
                    Oops! The page you're looking for doesn't exist or has been moved.<br />
                    Let's get you back on track.
                </p>

                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <button
                        id="not-found-go-home-btn"
                        onClick={handleGoHome}
                        className="bg-primary hover:bg-primary-hover px-6 py-2.5 text-white rounded-lg text-sm font-medium transition-all shadow-xs"
                    >
                        {isAuthenticated ? 'Go to Dashboard' : 'Go to Home'}
                    </button>
                    <button
                        id="not-found-go-back-btn"
                        onClick={() => navigate(-1)}
                        className="px-6 py-2.5 rounded-lg text-sm font-medium border border-gray-200 text-gray-600 hover:bg-gray-100 transition-all"
                    >
                        Go Back
                    </button>
                </div>

                {/* Subtle decorative dots */}
                <div className="mt-12 flex justify-center gap-2 opacity-30">
                    {[...Array(5)].map((_, i) => (
                        <div key={i} className="w-2 h-2 rounded-full bg-primary" style={{ opacity: 1 - i * 0.15 }} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default NotFound;
